/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_PeriodInputs */

const en_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const de_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/Monat`)
};

const fr_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mois`)
};

const es_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const it_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mese`)
};

const nl_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/maand`)
};

const pl_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/miesiąc`)
};

const fi_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kuukausi`)
};

const da_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/måned`)
};

const sv_settings_student_period = /** @type {(inputs: Settings_Student_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/månad`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Settings_Student_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_period = /** @type {((inputs?: Settings_Student_PeriodInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_PeriodInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_period(inputs)
	if (locale === "fr") return fr_settings_student_period(inputs)
	if (locale === "es") return es_settings_student_period(inputs)
	if (locale === "it") return it_settings_student_period(inputs)
	if (locale === "nl") return nl_settings_student_period(inputs)
	if (locale === "pl") return pl_settings_student_period(inputs)
	if (locale === "fi") return fi_settings_student_period(inputs)
	if (locale === "da") return da_settings_student_period(inputs)
	if (locale === "sv") return sv_settings_student_period(inputs)
	return en_settings_student_period(inputs)
});